// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__du8pg","text":"spinner_text__0eQXx"};